import { ICreateAssociation, inputAssociation } from '~/types/association-types'
import { normalizeCpfCnpj } from '~/utils/cnpj'

export function associationCreateMapper(requestType: ICreateAssociation) {
  return {
    ...requestType,
    documento: normalizeCpfCnpj(requestType.documento),
    telefone: requestType?.telefone
      ?.replace(/\s/g, '')
      ?.replace('(', '')
      ?.replace(')', '')
      ?.replace('+', '')
      ?.replace('55', ''),
  } as any
}

export function associationEditMapper(requestType: inputAssociation) {
  return {
    ...requestType,
    documento: normalizeCpfCnpj(requestType.documento),
    cidade_id: requestType.cidade_id.id ?? '',
    telefone: requestType?.telefone
      ?.replace(/\s/g, '')
      ?.replace('(', '')
      ?.replace(')', '')
      ?.replace('+', '')
      ?.replace('-', '')
      ?.replace('55', ''),
  } as any
}
